import { createRouter, createWebHistory } from 'vue-router'
import StatusPage from '../views/StatusPage.vue'
import CompareLayouts from '../views/CompareLayouts.vue'
import StatusPageVariant from '../views/StatusPageVariant.vue'

const routerBase = import.meta.env.VITE_ROUTER_BASE || '/'

const router = createRouter({
  history: createWebHistory(routerBase),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: StatusPage,
      beforeEnter: (to, from, next) => {
        // Check if this is a custom domain or subdomain
        const host = window.location.hostname;
        
        // If it's a custom domain or subdomain, load by domain
        if (host !== 'localhost' && host !== '127.0.0.1' && !host.includes('3001')) {
          // This is likely a custom domain or subdomain
          to.params.isDomain = 'true';
          to.params.domain = host;
        } else {
          // Default to demo status page for localhost
          to.params.slug = 'demo-status';
        }
        next();
      },
      props: true
    },
    {
      path: '/:slug',
      name: 'StatusPage',
      component: StatusPage,
      props: true
    },
    {
      path: '/compare/:slug?',
      name: 'CompareLayouts',
      component: CompareLayouts,
      beforeEnter: (to, from, next) => {
        // Check if this is a custom domain or subdomain
        const host = window.location.hostname;

        // If it's a custom domain or subdomain, load by domain
        if (host !== 'localhost' && host !== '127.0.0.1' && !host.includes('3001')) {
          // This is likely a custom domain or subdomain
          to.params.isDomain = 'true';
          to.params.domain = host;
        } else if (to.params.slug) {
          // Use the slug from the URL
          // slug is already set
        } else {
          // Default to demo status page for localhost
          to.params.slug = 'demo-status';
        }
        next();
      },
      props: true
    },
    {
      path: '/variant/:slug',
      name: 'StatusPageVariant',
      component: StatusPageVariant,
      props: true
    },
    {
      path: '/verify/:token',
      name: 'VerifySubscription',
      component: () => import('../views/VerifySubscription.vue'),
      props: true
    }
  ]
})

export default router
